import posthog from "posthog-js";

const VITE_ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT;

const trackingEnabled = VITE_ENVIRONMENT === "production";

posthog.init("phc_h6OfXcg2yvT9QdBdgugm5mLIXiga5nTTtBJz7852EOR", { api_host: "https://eu.posthog.com" });
export const posthogService = posthog;

export function trackEvent(event: string, properties?: Record<string, unknown>) {
  if (!trackingEnabled) {
    return;
  }
  posthog.capture(event, properties);
}
